import "../styles/vars.scss";
import SvgIcn from "../data/IconCompo";
import RightBarNav from "../ui/compoP/RightBarNav";
import LeftBarNav from "../ui/compoP/LeftBarNav";
import CenterBarNav from "../ui/compoP/CenterBarNav";
import ContentWrapper from "../ui/compoP/ContentWrapper";
import AllPopups from "../ui/compoP/AllPopups";
import { use, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setUserToken } from "../redux/actions";

function Layout({
  children,
  centerBar,
  leftBar,
  showLeftBar = true,
  showRightBar = true,
  title,
  icon,
  contentText,
  contentIcon,
  contentTitle,
  selectedMode,
  contentRef,
}) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (localStorage.getItem("token")) {
      dispatch(setUserToken(localStorage.getItem("token")));
    } else {
      dispatch(setUserToken(""));
    }
  }, []);
  return (
    <div className="page-hero">
      {showLeftBar && (
        <LeftBarNav selectedMode={selectedMode}>{leftBar}</LeftBarNav>
      )}
      {centerBar && (
        <CenterBarNav title={title} icon={icon} selectedMode={selectedMode}>
          {centerBar}
        </CenterBarNav>
      )}
      <ContentWrapper
        title={contentTitle}
        icon={contentIcon}
        text={contentText}
        ref={contentRef}
      >
        {children}
      </ContentWrapper>
      {showRightBar && <RightBarNav />}
      <AllPopups />
    </div>
  );
}

export default Layout;
